import React from 'react';
import { Settings, ArrowRight } from 'lucide-react';
import { Handle, Position } from 'reactflow';
import { WorkflowStep } from '../../types/workflow';

interface N8nConstructNodeProps {
  data: {
    constructStep: WorkflowStep | null;
    onEditStep: (step: WorkflowStep) => void;
  };
}

const N8nConstructNode: React.FC<N8nConstructNodeProps> = ({ data }) => {
  const step = data.constructStep;

  // derive quick stats
  const valueObj: Record<string, any> = step && step.inputs && typeof (step as any).inputs === 'object'
    ? ((step as any).inputs as any).value || {}
    : {};
  const paramCount = Object.keys(valueObj || {}).length;
  const nextTarget = step?.next || 'prepare-authdata';


  return (
    <div className="bg-n8n-dark-800 border border-n8n-dark-600 rounded-none shadow-n8n-xl w-[320px]">
      <div className="px-4 py-3 flex items-center justify-between border-b border-n8n-dark-600/80">
        <div className="flex items-center space-x-2">
          <div className="px-2 py-0.5 text-[10px] uppercase tracking-wider bg-n8n-primary-500/15 text-n8n-primary-300 rounded-full border border-n8n-primary-500/30">Middle Layer</div>
          <div className="text-n8n-dark-50 font-semibold">Construct EVM</div>
        </div>
        {step && (
          <button
            onClick={() => data.onEditStep(step)}
            className="flex items-center space-x-1 text-n8n-dark-300 hover:text-n8n-dark-100 hover:bg-n8n-dark-700 rounded px-2 py-1 transition-colors"
            title="Edit construct configuration"
          >
            <Settings size={16} />
            <span className="text-xs">Edit</span>
          </button>
        )}
      </div>

      <div className="px-4 py-3 text-sm text-n8n-dark-300 space-y-3">
        {step ? (
          <>

            <div className="text-n8n-dark-300">
              Bridges workflow outputs to system nodes. Select fields from any step as input; on export, parameters are auto-generated (nested objects become tuples).
            </div>
            <div className="flex items-center justify-between text-xs">
              <div className="flex items-center space-x-1 text-n8n-dark-400">
                <span>Next</span>
                <ArrowRight size={14} />
                <span className="text-n8n-dark-100">{nextTarget}</span>
              </div>
            </div>
            <div className="rounded-none border border-n8n-dark-700 bg-n8n-dark-900/40 p-3">
              <div className="text-xs text-n8n-dark-400 mb-1">Node</div>
              <div className="text-n8n-dark-100 text-sm">{step.name}</div>
            </div>
          </>
        ) : (
          <div className="text-n8n-dark-400">No construct node present.</div>
        )}
      </div>

      {/* Handles */}
      <Handle type="target" position={Position.Left} id="in" style={{ background: '#3b82f6' }} />
      <Handle type="source" position={Position.Right} id="out" style={{ background: '#3b82f6' }} />
    </div>
  );
};

export default N8nConstructNode;
